export enum ESocketActions {
  TotalInfoUpdate = 'totalInfoUpdate',
  IncomingMessage = 'incomingMessage',
  ChannelsUpdate = 'channelsUpdate'
}
